<template>
	<div class="margin-left">
		<div class="bg-white surplus">
			<p class="text-lg text-333 text-left">您当前账户积分剩余 <span>{{myintegral}}</span> </p>
			<el-row :gutter="20">
			  <el-col :span="8" v-for="(item,index) in list" :key="index">
				  <div class="bg-f7 recharge-item margin-top flex flex-direction justify-center align-center" :class="index == choseindex?'active':''" @click="choseitem(item,index)">
					  <p class="text-lg text-333":class="index == choseindex?'text-theme':''">充值{{item.integral}}积分</p>
					  <p class="fs28 text-999 margin-top":class="index == choseindex?'text-theme':''">￥{{item.price}}</p>
				  </div>
			  </el-col>
			</el-row>
		</div>
		<div class="flex align-center justify-between bg-white pay margin-top-sm">
			<!-- <div>
				<img class="block-139" src="../../../assets/img/ercode.png" >
				<p>微信扫码支付</p>
			</div> -->
			<div class="text-left margin-left-sm">
				<p class="flex align-center margin-bottom-sm">当前充值应付金额： <span class="fs36 text-prices">{{realyprice}}</span> </p>
				<p class="margin-bottom-sm">扫码付款表示我已阅读且同意<span class="text-theme">《蓝友用工平台积分充值条款》</span></p>
				<p class="text-999">如有疑问请联系平台客服：<span class="text-theme">400-212-22</span></p>
			</div>
			<div @click="buy" class="pointer text-white text-center call-btn flex align-center bg-theme margin-right justify-center">立即充值</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				list:[],
				myintegral:0,
				choseindex:0,
				realyprice:0,
				reaintegral:0
			};
		},
		created() {
			this.getMyIntegral()
			this.getrechargeInfo()
			
		},
		methods: {
			choseitem(item,index){
				this.choseindex = index
				this.realyprice = item.price
				this.reaintegral = item.integral
			},
			//获取我的积分
			getMyIntegral(){
				this.ajax('get', '/api/integral/getMyIntegral', {},res => {
					this.myintegral = res.data.integral
				})
			},
			//充值界面
			getrechargeInfo(){
				this.ajax('get', '/api/integral/rechargeInfo', {},res => {
					this.list = res.data
					this.realyprice = res.data[0].price
					this.choseindex = 0
					
					this.reaintegral = res.data[0].integral
				})
			},
			buy(){
				let data = {
					price:this.realyprice,
					integral:this.reaintegral,
				}
				console.log(data);
				this.ajax('post', '/api/integral/recharge',data,res => {
					if(res.status == 200){
						this.getMyIntegral()
					}
				})
			}
		}
	}
</script>

<style scoped lang="less">
	.call-btn {
		width: 150px;
		height: 40px;
		line-height: 40px;
		box-shadow: 0px 5px 29px 2px rgba(11, 131, 124, 0.3000);
		border-radius: 40px;
	}
	.surplus{
		width: 919px;
		height: 463px;
		background: #FFFFFF;
		box-shadow: 0px 2px 51px 0px rgba(34,34,34,0.08);
		border-radius: 16px;
		padding: 40px 28px;
		.recharge-item{
			height: 146px;
			border-radius: 8px;
		}
	}
	.bg-f7{
		background: #F7F7F7;
	}
	.fs28{
		font-size: 28px;
	}
	.fs36{
		font-size: 36px;
	}
	.active{
		background: rgba(9,130,123,0.1);
		border: 1px solid #09827B;
		position: relative;
		&:after{
			position: absolute;
			width: 21px;
			height: 21px;
			background: #09827B;
			border-radius: 50%;
			content: '';
			top: -5px;
			right: -6px;
		}
	}
	.pay{
		width: 919px;
		height: 194px;
		background: #FFFFFF;
		box-shadow: 3px 4px 19px 1px rgba(204,204,204,0.3);
		border-radius: 20px;
		padding-left: 40px;
	}
	.block-139{
		width: 139px;
		height: 139px;
	}
</style>



// WEBPACK FOOTER //
// src/components/my/integral/recharge.vue